import Vue from "vue";
import paddy from "../common/paddy";

Vue.filter("paddy", paddy);
